"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  number: "01",
  title: "Request Your Free Inspection",
  description: "Request your free inspection by phone or online."
}, {
  number: "02",
  title: "Thorough Property Evaluation",
  description: "We inspect your home's exterior, entry points, and problem areas."
}, {
  number: "03",
  title: "Clear Findings & Honest Recommendation",
  description: "We explain what we find and give you a clear, no-obligation recommendation and quote."
}, {
  number: "04",
  title: "Targeted Treatment & Ongoing Defense",
  description: "We treat your home and, if you choose a plan, continue with quarterly service."
}];
export default function InspectionProcess() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="inspection-process" id="inspection-process" className="bg-background text-foreground py-20 md:py-28 border-b border-border">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="block h-px w-8 bg-primary" />
            <span className="font-mono text-xs uppercase tracking-widest text-primary">
              Simple &amp; Transparent
            </span>
            <span className="block h-px w-8 bg-primary" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            How Our Free Inspection Works
          </h2>
          <p className="text-base md:text-lg text-muted-foreground font-sans">
            A straightforward process with no pressure, designed to evaluate your property&apos;s specific pest pressures.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {steps.map((step, index) => <div key={index} data-index={index} className="border border-border bg-card rounded-md p-6 shadow-sm flex flex-col relative">
              <div className="font-serif italic text-4xl text-primary font-semibold mb-4">
                {step.number}
              </div>
              <h3 className="text-lg font-bold font-default text-foreground mb-3">
                {step.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed font-sans">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}